import React from 'react';
import ReactDOM from 'react-dom/client';
import { 
  createBrowserRouter, 
  RouterProvider
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import './output.css'; // Import the generated Tailwind CSS

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

// Create router with future flags to address v7 migration warnings
const router = createBrowserRouter(
  [
    {
      path: '*',
      element: <App />
    }
  ],
  {
    // Using any type to bypass TypeScript checking for the future flags
    // These flags are available in react-router-dom but not properly typed yet
    future: {
      // @ts-ignore - These are valid flags according to the warning messages
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  } as any
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
